import { useSelector } from "react-redux";
import { StoreState } from "../interfaces/storeState";

export const useMarket = (): string => useSelector(getMarket);

const getMarket = (state: StoreState): string => state.market;
